/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React, { Fragment } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Component imports
import TestSetsTable from '../Tables/TestSetsTable';
import SideModal from '../Layout/SideModal';

// Misc imports
import { TEST_SETS_SEARCH_PARAMS } from '../../constants/testSets';
import { useTestSetNavigation } from '../../utils/hooks/useTestSetsNavigation';
import TestSetModal from '../Modals/TestSetModal';

const TestSetsEditor = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const { navigateToTestSetsList } = useTestSetNavigation();
  const searchParams = new URLSearchParams(location.search);

  return (
    <Fragment>
      <TestSetsTable />

      <SideModal
        open={searchParams.has(TEST_SETS_SEARCH_PARAMS.CREATE_TEST) || searchParams.has(TEST_SETS_SEARCH_PARAMS.ACTIVE_TEST)}
        onClose={() => navigateToTestSetsList()}
        title={
          (() => {
            const testSetName = searchParams.get(TEST_SETS_SEARCH_PARAMS.ACTIVE_TEST_NAME);

            if(searchParams.has(TEST_SETS_SEARCH_PARAMS.CREATE_TEST)) {
              return t(`Create New Test Set`);
            }
            if(testSetName) {
              return `Edit ${testSetName}`;
            }
            return null;
          })()
        }
        bodyClassName="p-0"
        destroyOnClose
        hasFullScreenButton={true}
        width={1080}
      >
        <TestSetModal
          bodyClassName="px-6 pt-6 flex-grow-1"
          footerClassName="ant-drawer-footer"
          isCreateMode={!!searchParams.has(TEST_SETS_SEARCH_PARAMS.CREATE_TEST)}
          defaultActiveTab={searchParams.get(TEST_SETS_SEARCH_PARAMS.ACTIVE_TAB)}
          activeTestSetId={searchParams.get(TEST_SETS_SEARCH_PARAMS.ACTIVE_TEST)}
        />
      </SideModal>
    </Fragment>
  );
};

export default TestSetsEditor;
